<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="contact-information">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Sécurité d'accès au scrutin</p>
        <p class="no-margin dark-gray bold">Options de sécurité supplémentaires pour l'accès au vote</p>
      </div>
    </div>
  </div>

  <div id="sending-mode" class="p-20">
    <p class="dark-blue bold no-margin mb-10">Sélection du mode de sécurité</p>
    <div>
      <label class="flex align-items-start gap-10 mb-10">
        <input type="checkbox" name="doubeFA" [value]="false" [(ngModel)]="is2FA" (change)="on2FAChange()">
        <div class="flex flex-column">
          <span class="dark-blue">Authentification renforcée (2FA – envoi d'un code personnel unique par SMS)</span>
          <span class="dark-gray text-xs">Un code de vérification sera envoyé par SMS à chaque connexion</span>
          <label *ngIf="is2FA" class="flex align-items-start gap-10 mb-10 mt-5">
            <input type="checkbox" name="phoneChangeable" [value]="false" [(ngModel)]="phoneChangeable"
              (change)="onPhoneChangeable()">
            <div class="flex flex-column">
              <span class="dark-blue">Numéros de téléphone modifiables par le votant</span>
              <span class="dark-gray text-xs">S'il le souhaite, l'électeur pourra changer son numéro de téléphone pour
                recevoir le code.</span>
            </div>
          </label>
        </div>
      </label>

      <label class="flex align-items-start gap-10">
        <input type="checkbox" name="challenge" [value]="false" [(ngModel)]="hasPassword"
          (change)="onPasswordToggleChange()">
        <div class="flex flex-column">
          <span class="dark-blue">Ajouter une question défi</span>
          <span class="dark-gray text-xs">Une question supplémentaire sera posée pour vérifier l'identité du
            votant</span>
          <input *ngIf="hasPassword" type="text" name="challenge" id="challenge"
            class="w-full text-md dark-blue pap-input mt-10" placeholder="Ex: Quelle est votre date de naissance ?"
            [(ngModel)]="password" (ngModelChange)="passwordChange.emit($event)">
          <!-- [(ngModel)]="application.challenge" (ngModelChange)="onApplicationChange()" -->
        </div>
      </label>

      <label class="flex align-items-start gap-10 mt-10">
        <input type="checkbox" name="challenge" [value]="false">
        <div class="flex flex-column">
          <span class="dark-blue">Conserver les liens de connexion entre les deux tours</span>
          <span class="dark-gray text-xs">L'utilisateur accedera aux différents tours sur le même lien de
            connexion</span>
        </div>
      </label>
    </div>
  </div>
</div>